import { apolloClient } from "@/plugins/apollo";
import {
    MY_TENANT_DASHBOARD_QUERY,
    CREAT_TENANT_USER_GROUP_MUTATION,
    UPDATE_TENANT_USER_GROUP_MUTATION,
    DELETE_TENANT_USER_GROUP_MUTATION
} from "@/graphql/tenants.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async fetchMyTenantDashboard() {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: MY_TENANT_DASHBOARD_QUERY
                })
                .then(response => {
                    // console.log(response);

                    const myTenantDashboard = JSON.parse(
                        JSON.stringify(response.data.myTenantDashboard)
                    );

                    resolve(myTenantDashboard);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createTenantUserGroup(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREAT_TENANT_USER_GROUP_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const tenantUserGroup =
                        response.data.createTenantUserGroup.tenantUserGroup;

                    resolve(tenantUserGroup);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateTenantUserGroup(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_TENANT_USER_GROUP_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const tenantUserGroup =
                        response.data.updateTenantUserGroup.tenantUserGroup;

                    resolve(tenantUserGroup);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteTenantUserGroup(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_TENANT_USER_GROUP_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const tenantUserGroup =
                        response.data.deleteTenantUserGroup.tenantUserGroup;

                    resolve(tenantUserGroup);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
